import { SkiIcon } from './SkiIcon';

/**
 * author: Google
 * id 197B0D1A-34DB-4FD7-825B-FFE5C28297BB
 * name ski
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ski.svg
 * tags
 * - Sport 
 * - People / Family 
 */
export const HumanSkiIcon = SkiIcon;
export default HumanSkiIcon